import { API_CONFIG } from '../config/api';
import { ApiResponse } from '../types';
import { 
  Dict, 
  CreateDictDto, 
  UpdateDictDto, 
  DictQueryParams, 
  DictListResponse,
  SetDictValueDto 
} from '../types/dict';
import { http, buildUrl } from './base';

/**
 * 字典管理相关 API 服务
 */
export class DictService {
  /**
   * 获取字典列表
   */
  static async getDictList(params?: DictQueryParams): Promise<ApiResponse<DictListResponse>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.DICT.LIST, params as any);
    return http.get(url);
  }

  /**
   * 创建字典
   */
  static async createDict(data: CreateDictDto): Promise<ApiResponse<Dict>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.DICT.CREATE);
    return http.post(url, data);
  }

  /**
   * 获取字典详情
   */
  static async getDictDetail(id: number): Promise<ApiResponse<Dict>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.DICT.DETAIL, { id: id.toString() });
    return http.get(url);
  }

  /**
   * 更新字典
   */
  static async updateDict(id: number, data: UpdateDictDto): Promise<ApiResponse<Dict>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.DICT.UPDATE, { id: id.toString() });
    return http.patch(url, data);
  }

  /**
   * 删除字典
   */
  static async deleteDict(id: number): Promise<ApiResponse<void>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.DICT.DELETE, { id: id.toString() });
    return http.delete(url);
  }

  /**
   * 根据类型获取字典
   */
  static async getDictByType(dictType: string): Promise<ApiResponse<Dict[]>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.DICT.FIND_BY_TYPE, { dictType });
    return http.get(url);
  }

  /**
   * 根据类型获取字典值
   */
  static async getDictValue(dictType: string): Promise<ApiResponse<string>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.DICT.GET_VALUE, { dictType });
    return http.get(url);
  }

  /**
   * 设置字典值
   */
  static async setDictValue(data: SetDictValueDto): Promise<ApiResponse<void>> {
    const url = buildUrl(API_CONFIG.ENDPOINTS.DICT.SET_VALUE);
    return http.post(url, data);
  }
}

export default DictService;
